<template>
  <b-form-group
    v-if="isPremium && dataItem.next_repeat_date"
    :label="$t('tasks.form.nextRepeatDate')"
  >
    <b-form-input
      :value="formattedDate"
      readonly
      disabled
    />
    <small class="text-muted">{{ $t('tasks.form.nextRepeatHint') }}</small>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { packageLimit, PKG_PREMIUM } from '@/libs/packageLimits'

export default {
  name: 'TasksNextRepeatDateCard',
  components: { BFormGroup, BFormInput },
  computed: {
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isPremium() {
      return packageLimit('PROJECTS', PKG_PREMIUM)
    },
    formattedDate() {
      if (!this.dataItem.next_repeat_date) return ''
      return this.moment(this.dataItem.next_repeat_date).format('DD.MM.YYYY')
    },
  },
}
</script>
